/**
 * Centralised legal info for the site.
 * Used across Privacy, Cookie, Terms, Note Legali pages and the Footer.
 */

export const LEGAL = {
  ownerName: "Michele Roccaro",
  ownerRole: "Titolare del trattamento dei dati personali",
  address: "Via Larga Palme, 76 — 97018 Scicli (RG) — Italia",
  fiscalCode: "RCCMHL86M13I535N",
  email: "metododimare@gmail.com",
  whatsapp: "+39 377 366 0476",
  whatsappWa: "393773660476",
  siteUrl: "https://metododimare.com",
  acdtAddress: "Via Giordano Cavestro, 1 — 97019 Vittoria (RG)",
  acdtLaw: "Legge 4 del 14 gennaio 2013",
  bookTitle: "Metodo di Mare",
  bookIsbn: "979-1282209199",
  bookAmazon: "https://amzn.eu/d/0iLs59IO",
  lastUpdated: "Dicembre 2025",
};
